import React from "react";
import { useTranslation } from "react-i18next";

const ReportTypeOptions = ({
  selectedOption,
  onChange,
  view = false,
  labelClass = "form-radio-label pointer-cursor ml-2 pt-1 text-primary",
  inputClass = "form-check-input pointer-cursor",
}) => {
  const { t } = useTranslation();

  const options = [
    ...(view ? [{
      value: "view",
      label: t("View"),
      icon: "fa-eye",
    }] : []),
    {
      value: "excel",
      label: t("Excel"),
      icon: "fa-table",
    },
    {
      value: "print",
      label: t("Print"),
      icon: "fa-print",
    },
  ];

  return (
    <div className="d-flex flex-wrap">
      {options.map((opt, index) => (
        <div
          key={opt.value}
          className={`d-inline d-flex align-items-center ${
            index != options.length - 1 ? "mr-3 " : ""
          }`}
        >
          <input
            type="radio"
            id={opt.id || opt.value}
            name={opt.name || "option_selector"}
            value={opt.value}
            checked={selectedOption === opt.value}
            onChange={onChange}
            className={inputClass}
          />
          <label
            htmlFor={opt.id || opt.value}
            className={labelClass}
            style={{ fontSize: "16px", borderRadius: "5px" }}
          >
            {opt.icon && (
              <i className={`fa ${opt.icon}`} aria-hidden="true"></i>
            )}{" "}
            {opt.label}
          </label>
        </div>
      ))}
    </div>
  );
};

export default ReportTypeOptions;
